// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "47e43417d7c76476c0cf909eb9ef734e0099c584/static/css/" + chunkId + "." + "f83a2947" + ".chunk.css";
};